import ConfirmModal, { ConfirmModalHeader } from "PFComponents/confirm/confirm_modal";
import { Typography } from "PFComponents/typography";
import React, { JSX } from "react";
import { useTranslation } from "react-i18next";

type ConfirmDeleteModalProps = {
  reportName: string;
  onDelete: VoidFunction;
  onClose: VoidFunction;
};

export const ConfirmDeleteModal = ({
  reportName,
  onClose,
  onDelete
}: ConfirmDeleteModalProps): JSX.Element => {
  const { t } = useTranslation(["insights", "translation"]);

  return (
    <ConfirmModal labelOK={t("translation:delete")} handleOK={onDelete} handleClose={onClose}>
      <ConfirmModalHeader>{t("insights:reports.deleteReport.title")}</ConfirmModalHeader>
      <Typography variant="bodyRegular">
        {t("insights:reports.deleteReport.content", { reportName })}
      </Typography>
    </ConfirmModal>
  );
};
